import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

import UserSessionContext from 'context/UserSessionContext';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    textAlign: 'center',
    marginTop: theme.spacing(1)
  }
}));

const Profile = ({ className, ...rest }) => {
  const classes = useStyles();
  const { session } = useContext(UserSessionContext);
  const { user } = session;
  const { username, role } = user;
  return (
    <div {...rest} className={classNames(classes.root, className)}>
      <Avatar alt="Person" className={classes.avatar} />
      <Typography className={classes.name} variant="h6">
        {username}
      </Typography>
      <Typography variant="body2">{role}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

Profile.defaultProps = {
  className: ''
};

export default Profile;
